import React from 'react';
export const TimeSlotsMock = [
  { time: '09:00 - 09:45', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '09:30 - 10:15', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '10:00 - 10:45', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '10:30 - 11:15', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '11:00 - 11:45', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '11:30 - 12:15', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '12:00 - 12:45', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '12:30 - 13:15', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '13:00 - 13:45', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '13:30 - 14:15', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '14:00 - 14:45', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '14:30 - 15:15', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '15:00 - 15:45', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '15:30 - 16:15', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '16:00 - 16:45', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '16:30 - 17:15', total_people: 0, status: "active",total_adults: 0,total_children: 0 },
  { time: '17:00 - 17:45', total_people: 0, status: "active" ,total_adults: 0,total_children: 0},
  { time: '17:30 - 18:15', total_people: 0, status: "active",total_adults: 0,total_children: 0 }
];
